import React from 'react'
import { FormattedMessage } from 'react-intl'
import useLocale from '../../hooks/useLocale'
import LazyImage from '../LazyImage/LazyImage'

const chip = {
  src: require('./logos/chip.svg'),
  alt: 'Chip',
}
const DI = {
  src: require('./logos/dagens-industri.svg'),
  alt: 'DI Digital',
}
const dailyExpress = {
  src: require('./logos/daily-express.svg'),
  alt: 'Daily Express',
}
const everydayHealth = {
  src: require('./logos/everyday-health.svg'),
  alt: 'Everyday Health',
}
const forbes = {
  src: require('./logos/forbes.svg'),
  alt: 'Forbes',
}
const houseBeautiful = {
  src: require('./logos/house-beautiful.svg'),
  alt: 'House Beautiful',
}
const mensHealth = {
  src: require('./logos/mens-health.svg'),
  alt: 'Men’s Health',
}
const netdoctor = {
  src: require('./logos/netdoctor.svg'),
  alt: 'NetDoctor',
}
const TC = {
  src: require('./logos/techcrunch.svg'),
  alt: 'TechCrunch',
}
const tomsGuide = {
  src: require('./logos/toms-guide.svg'),
  alt: 'Tom’s Guide',
}
const vogue = {
  src: require('./logos/vogue.svg'),
  alt: 'Vogue',
}
const yahoo = {
  src: require('./logos/yahoo.svg'),
  alt: 'Yahoo!',
}

const allLogos = {
  US: [vogue, TC, everydayHealth, forbes, tomsGuide],
  GB: [vogue, netdoctor, TC, dailyExpress, houseBeautiful],
  IE: [vogue, netdoctor, TC, dailyExpress, houseBeautiful],
  DE: [vogue, TC, chip, forbes, yahoo],
  SE: [DI, TC, vogue, forbes, yahoo],
  OTHER: [TC, vogue, yahoo, forbes, mensHealth],
}

export default function AsSeenIn() {
  const { country } = useLocale()
  const logos = allLogos[country] || allLogos.OTHER

  return (
    <section className="text-center">
      <h1 className="type-upper-fat text-TypeSub mb-12 md:mb-20 lg:mb-40">
        <FormattedMessage id="Press.asSeenIn" defaultMessage="As seen in" />
      </h1>
      <div className="flex flex-wrap justify-center lg:grid lg:grid-cols-5 lg:gap-6">
        {logos.map(({ src, alt }, i) => {
          return (
            <LazyImage
              width={300}
              height={60}
              className="w-1/3 my-12 md:my-16 lg:my-0 lg:w-auto"
              key={i}
              src={src}
              alt={alt}
            />
          )
        })}
      </div>
    </section>
  )
}
